<div class="flex flex-col gap-2" [formGroup]="pharmacyForm()">
  <label for="tax" class="text-[14px] font-[500] hover:cursor-pointer" i18n="@@adminCreatePharmacyTaxLabel">
    Tax Identification Number
    <span class="text-danger-text">*</span>
  </label>
  <input
    id="tax"
    type="text"
    formControlName="taxIdentificationNumber"
    placeholder="Enter Tax Identification Number"
    i18n-placeholder="@@adminCreatePharmacyTaxPlaceholder"
    class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"
    [class.border-red-500]="
      pharmacyForm().get('taxIdentificationNumber')?.invalid && pharmacyForm().get('taxIdentificationNumber')?.touched
    " />
  @if (
    pharmacyForm().get("taxIdentificationNumber")?.invalid && pharmacyForm().get("taxIdentificationNumber")?.touched
  ) {
    <span class="text-danger-text text-[12px]">
      @if (pharmacyForm().get("taxIdentificationNumber")?.errors?.["required"]) {
        <span i18n="@@adminCreatePharmacyFormErrorTaxRequired">Tax Identification Number is required</span>
      }
      @if (
        (pharmacyForm().get("taxIdentificationNumber")?.errors?.["minlength"] ||
          pharmacyForm().get("taxIdentificationNumber")?.errors?.["maxlength"]) &&
        !pharmacyForm().get("taxIdentificationNumber")?.errors?.["pattern"]
      ) {
        <span i18n="@@adminCreatePharmacyFormErrorTaxLength">Tax Identification Number must be exactly 9 digits</span>
      }
      @if (pharmacyForm().get("taxIdentificationNumber")?.errors?.["pattern"]) {
        <span i18n="@@adminCreatePharmacyFormErrorTaxNumeric">Tax Identification Number must contain only numbers</span>
      }
    </span>
  }
</div>
